/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import 'ag-grid-enterprise';
import {
    createStyles,
    WithStyles,
    withStyles
} from '@mui/styles';
import { Theme } from '@mui/material/styles';
import {
    inject,
    observer
} from 'mobx-react';
import * as React from 'react';
import { RootStore } from '../../stores/root.store';
import { SideNavbar } from '../../shared/components/side-navbar';
import ArticleIcon from '@mui/icons-material/Article';
import {
    Button,
    Divider,
    IconButton,
    Typography,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    SelectChangeEvent,
    FormControlLabel,
    Checkbox
} from '@mui/material';
import { CCSnackbar, CCSnackbarVariant } from '../../shared/components/cc-snackbar';
import { SimpleDialog } from '../../shared/components/simple-dialog';
import { RenderTree } from '../../shared/components/node-tree';
import { SearchResults, SearchResultsUser, SearchResultsWithAccount } from '../../adapters/report-base-adapter';
import {
    EntityFolder,
    Floorplan,
    Folder,
    PCNList,
    ScheduleRow,
    UserTeam,
    EntityPCN,
    RouteGridList,
    RouteGridItem,
    ShiftLabelParameters,
    SessionTypeParameters,
    RouteFrequency
} from '../../shared/domain';
import { PCN_ROUTES, REPORTS, WEEKDAYS } from '../../constants';
import { NavigationListItem } from '../../components/navigation-list';
import { CCSpinner } from '../../shared/components/cc-spinner';
import { FolderTree } from '../../components/folder-tree';
import { JobCreationResult, JobTypes, RunningJobs, STATIC_PROGRESS_LIMIT, StatusTypes } from '../../models/jobs';
import { MainTabs } from '../../stores/manager.store';
import { RunningJobsList } from '../../components/running-jobs-list';
import { PageBoundary, SimpleListPagination } from '../../shared/components/simple-list-pagination';
import { HourglassBottom, PictureAsPdf } from '@mui/icons-material';
import { AgGridList, ValidAgGridRowModel } from '../../shared/components/ag-grid-list';
import { CellValueChangedEvent, ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { CustomCellRendererProps, CustomCellEditorProps } from 'ag-grid-react';
import { SimpleModal } from '../../shared/components/simple-modal';
import { SimpleList, SimpleListItem } from '../../shared/components/simple-list';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PlaceIcon from '@mui/icons-material/Place';
import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek';
import { ccLogoBottom } from '../../shared/assets/images/cc-logo';
import memoize from 'memoize-one';
import jsPDF from 'jspdf';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { splitList } from '../../shared/utils/split-list';
import { CHICAGO_LOGO } from '../../shared/assets/images/chicago-logo';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import AddIcon from '@mui/icons-material/Add';
import ListIcon from '@mui/icons-material/List';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CancelIcon from '@mui/icons-material/Close';
import { UserPermissions } from '../../models/registered-user';
import { LeafletPDFData, PDF2JPGConvertion, PDFApiMarker } from '../../shared/domain/leaflet';
import { LeafletPDFClient } from '../../shared/components/leaflet-pdf-client';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';

dayjs.extend(timezone);
dayjs.extend(utc);

const ROUTE_CREATED_SUCCESFULLY = 'Route created successfully';
const FOLDER_PERMISSIONS = 'route_read,route_write';
const TASKS_ROWS_PER_PAGE = 5;
const TASKS_PAGING_LIMIT = 100;
// Set default for routes prefix
let CC_ROUTES_NAME: string | undefined = undefined;


const PDF_LOGO: {[key: string]: string } = {
    'PCN': CHICAGO_LOGO
};

type ModalTypeProp = 'DEFAULT' | 'NEW' | 'LIST';
const MODAL_TYPE = {
    DEFAULT: 'DEFAULT' as ModalTypeProp,
    NEW: 'NEW' as ModalTypeProp,
    LIST: 'LIST' as ModalTypeProp
};

const styles = (theme: Theme) => createStyles({
    divider: {
        margin: '1.6em 0 1.55em 0',
    },
    contentContainer: {
        '&, &$navbarContent': {
            padding: '1.45em',
        },
        [theme.breakpoints.between(
            'xs',
            theme.breakpoints.values.iPhone8_Landscape
        )]: {
            padding: '0',
        },
    },
    dataGridContainer: {
        padding: '2em 2em 3.8em',
        width: 'calc(100% - 4em)',
        '&.navbar-opened': {
            width: 'calc(100% - 20.2em)',
            transition: theme.transitions.create(['width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.standard,
            })
        },
        '& .MuiDataGrid-row': {
            cursor: 'pointer',
            '& .MuiDataGrid-cell:focus': {
                outline: '0'
            }
        },
        '& .ag-checkbox-input-wrapper.ag-checked': {
            '&::before': {
                background: theme.palette.primary.main,
                transform: 'scale(2.2)',
                top: '2px'
            },
            '&::after': {
                color: 'white',
                transform: 'scale(1.8)',
                top: '1px'
            },
            '&.ag-disabled::before': {
                transform: 'scale(1.5)'
            }
        }
    },
    gridWrapper: {
        height: 'calc(100vh - 22em)',
        '& .ag-cell.row-selected-cell': {
            background: '#f9f9f9',
            borderLeftColor: '#ddd',
            display: 'flex',
            justifyContent: 'center'
        }
    },
    errorContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: 1,
        margin: '0 2em'
    },
    errorMessage: {
        width: '100%',
        color: 'red',
        fontWeight: 400,
        textAlign: 'center',
        margin: '1em'
    },
    navbarIconContainer: {
        padding: '0.3em 0.4em',
        backgroundColor: theme.palette.secondary.main,
    },
    navbarIconContainerSmall: {
        transform: 'scale(0.7)',
        margin: '0.7em',
    },
    navbarIcon: {
        color: 'white',
    },
    navbarContent: {
        display: 'flex',
        flex: '1 0 0',
        flexDirection: 'column',
        width: '20em',
    },
    navbarTitleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    navbarTitle: {
        fontWeight: 'bold',
        marginLeft: '0.4em',
    },
    bodyTitle: {
        marginBottom: '0.4em',
    },
    modalContainer: {
        padding: '2em',
        maxWidth: '55em',
        width: '100%'
    },
    modalHeaderContainer: {
        position: 'relative',
        padding: '8px'
    },
    modalTitle: {
        fontSize: '2em',
        fontWeight: 'bold',
        marginBottom: '0.5em'
    },
    navbarComponentTitle: {
        color: theme.palette.grey[500],
        fontSize: '0.9em',
        fontWeight: 600,
        marginBottom: '0.3em',
    },
    modalCloseButton: {
        position: 'absolute',
        right: '0',
        top: '0'
    },
    modalSectionContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap'
    },
    modalBodyList: {
        padding: '0',
        listStyle: 'none',
        minWidth: '14em',
        '& li': {
            padding: '0.9em 0'
        },
        '& span': {
            fontWeight: 'bold',
            marginRight: '0.5em'
        }
    },
    bodyLeftColumn: {
        width: '32em'
    },
    headerColumn: {
        padding: '0.3em 0',
        width: '22em'
    },
    moduleGroupField: {
        width: '100%',
        minWidth: '14.3em'
    },
    snackbar: {
        top: '7em',
    },
    navbarInput: {
        width: '100%',
        paddingLeft: '0.4em',
    },
    navbarPlaceholder: {
        fontSize: '0.9em',
    },
    routeNavButton: {
        width: '100%',
        height: '4em',
        marginBottom: '1em',
        '& .MuiSvgIcon-root': {
            marginRight: '0.2em',
            transform: 'scale(0.9)'
        }
    },
    treeContainer: {
        padding: '2em',
        flex: '1'
    },
    spinner: {
        zIndex: 1301,
        position: 'fixed',
    },
    tasksContainerSize: {
        flex: 1,
        '& .MuiListItem-root': {
            padding: '0.5em !important'
        }
    },
    topMargin: {
        marginTop: '2em'
    },
    editCell: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    dropdownGrid: {
        borderBottom: '1px solid',
        display: 'inline-block',
        flex: '1',
        position: 'relative',
        paddingRight: '32px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        '& .MuiButtonBase-root': {
            position: 'absolute',
            right: '0'
        }
    },
    pcnModal: {
        width: '90%',
        maxWidth: '90em',
        padding: '0.5em',
        borderRadius: '0.4em'
    },
    pcnModalLight: {
        minWidth: '32em',
        maxWidth: '37em',
        padding: '0.5em',
        borderRadius: '0.4em'
    },
    pcnModalFooter: {
        alignItems: 'center',
        flex: 1,
        padding: '1em',
        display: 'flex',
        justifyContent: 'space-between'
    },
    pcnModalTitle: {
        marginTop: '1em',
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '0.2em',
        borderBottom: '1px solid'
    },
    pcnModalContent: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        gap: '1.5em'
    },
    pcnModalContainer: {
        padding: '1.5em 0 0',
        width: '100%',
        height: '100%'
    },
    pcnInput: {
        width: '100%',
        marginBottom: '1.5em'
    },
    pcnListSection: {
        width: '100%',
        maxWidth: '56em'
    },
    pcnList: {
        marginTop: '1em',
        height: '42em',
        overflow: 'auto'
    },
    pcnFormSection: {
        minWidth: '30em'
    },
    floorplanList: {
        marginTop: '1em',
        maxHeight: '16em',
        overflow: 'auto'
    },
    mapContainer: {
        padding: '2em',
        width: '100%',
        height: '90vh'
    },
    mapWrapper: {
        height: '92%',
        width: '100%',
        minHeight: '35em',
        minWidth: '50em',
        margin: '2em 0',
        border: '1px solid',
        borderColor: theme.palette.grey[500]
    },
    modal: {
        position: 'absolute',
        padding: '3em'
    },
    gridActionsBtn: {
        '& .MuiSvgIcon-root': {
            marginRight: '0.3em'
        }
    },
    pcnActionsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    moduleGroupSelector: {
        '& .MuiSelect-select' : {
            paddingTop: '0.8em',
            paddingBottom: '0.8em'
        }
    },
    frequencySelector: {
        '& .MuiSelect-select' : {
            paddingTop: '0.8em',
            paddingBottom: '0.8em'
        }
    },
    thinClientContainer: {
        height: '50em',
        marginBottom: '3em',
        transition: 'width 1s',
        [theme.breakpoints.down('lg')]: {
            maxHeight: '35em'
        }
    },
    fullScreenContainer: {
        top: '6.4em',
        height: '86%'
    },
    warningLeafletToast: {
        position: 'absolute',
        zIndex: 1001,
        right: 0
    },
    animContainer: {
        transition: 'width 1s',
        marginTop: '0.5em'
    },
    daysEditor: {
        padding: '0.5em',
        backgroundColor: theme.palette.background.paper,
        width: '27.6em'
    },
    daysEditorButtons: {
        marginTop: '0.5em',
        display: 'flex',
        justifyContent: 'space-between',
    },
    daysEditorTitle: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    noDaysEditor: {
        display: 'flex',
        padding: '1em',
        backgroundColor: theme.palette.background.paper,
        width: '23em'
    },
    gridHint: {
        position: 'relative',
        fontStyle: 'italic',
        left: '1em',
        top: '0.3em',
        [theme.breakpoints.down('lg')]: {
            display: 'none'
        }
    },
    monthlyDays: {
        position: 'relative',
        margin: 0,
        '& > .MuiFormControlLabel-label': {
            position: 'absolute',
            display: 'block',
            width: '100%',
            textAlign: 'center',
            color: '#1f1f1f'
        },
        '& svg': {
            fontSize: '3rem'
        },
        '& > .Mui-checked ~ .MuiFormControlLabel-label': {
            color: '#fff'
        }
    }
});

interface SchedulingRoutesDic {
    portal3_tab: {
        default_grid_values: { [key: string]: string };
        route_columns_definition: ColDef[];
        shift_labels: GridUser[];
        default_pcl_team_id: string;
        routes_prefix?: string;
        version: number;
    };
}

interface GridUser {
    value: string,
    label: string
}

interface LocationFilterCallbackTypeWithAccount<T> {
    data: ReadonlyArray<T>;
    total: number;
    accountId: string;
    accountName: string;
}

interface Props extends WithStyles<typeof styles> {
    rootStore: RootStore;
    userTeam?: UserTeam;
}

interface States {
    errorMessage: string;
    totalMarkers: number;
    isRoutesDrawerOpen: boolean;
    snackbarVariant: CCSnackbarVariant;
    snackbarMessage: string;
    snackbarOpen: boolean;
    dialogOpen: boolean;
    dialogTitle: string;
    dialogMessage: string;
    treeFolders: RenderTree;
    treeFoldersClicked: string[];
    treeFoldersExpanded: string[];
    gridRows: ValidAgGridRowModel[];
    initialGridRows: string;
    gridColumns: ColDef[];
    isCreateNewRoute: boolean;
    selectedFolder: EntityFolder | undefined;
    selectedPcn: EntityPCN | undefined;
    users: SearchResultsUser[];
    userListId: string;
    isPreviewGridMode: boolean;
    isNewSchedule: boolean;
    runningJobs: RunningJobs[];
    currentJobsOffset: number;
    isPcnModalOpen: boolean;
    currentPcn: string;
    pcnField: string;
    shiftLabels: ShiftLabelParameters[];
    currentShiftLabel: {
        id: number,
        name: string
    } | undefined;
    sessionTypes: SessionTypeParameters[];
    currentSessionType: {
        id: number,
        name: string
    } | undefined;
    frequencies: RouteFrequency[];
    isMapsSectionOpen: boolean;
    floorplanList: SimpleListItem[];
    selectedFloorplan: {
        floorplanId: string,
        floorplanName: string
    } | undefined;
    pcnOffset: number;
    pcnPage: number;
    isGridUpdated: boolean;
    openSaveGridModal: boolean;
    closeSaveGridModalCallback: () => void;
    isOpenEditPCNModal: boolean;
    isOpenDeletePCNModal: boolean;
    isShiftLabelEdit: boolean;
    showDeletePCNBtn: boolean;
    showCreateEditPCNButtons: boolean;
    pcnModalType: ModalTypeProp;
    dataGridList: RouteGridList;
    leafletPayload: LeafletPDFData | null;
}

@inject('rootStore')
@observer
class RoutesTab extends React.Component<Props, States> {
    public static defaultProps = {
    };
    
    state: States = {
        errorMessage: '',
        totalMarkers: 0,
        isRoutesDrawerOpen: true,
        snackbarVariant: 'info' as CCSnackbarVariant,
        snackbarMessage: '',
        snackbarOpen: false,
        dialogOpen: false,
        dialogTitle: '',
        dialogMessage: '',
        treeFolders: {
            id: 'treeRoot',
            name: 'Folders',
            children: [],
        },
        treeFoldersClicked: [],
        treeFoldersExpanded: [],
        gridRows: [],
        initialGridRows: '',
        gridColumns: [],
        isCreateNewRoute: false,
        selectedFolder: undefined as EntityFolder | undefined,
        selectedPcn: undefined as EntityPCN | undefined,
        users: [] as SearchResultsUser[],
        userListId: '',
        isPreviewGridMode: false,
        isNewSchedule: false,
        runningJobs: [],
        currentJobsOffset: 0,
        isPcnModalOpen: false,
        currentPcn: '',
        pcnField: '',
        shiftLabels: [] as ShiftLabelParameters[],
        currentShiftLabel: undefined,
        sessionTypes: [] as SessionTypeParameters[],
        currentSessionType: undefined,
        frequencies: [] as RouteFrequency[],
        isMapsSectionOpen: false,
        floorplanList: [],
        selectedFloorplan: undefined,
        pcnOffset: 0,
        pcnPage: 0,
        isGridUpdated: false,
        openSaveGridModal: false,
        isOpenEditPCNModal: false,
        isOpenDeletePCNModal: false,
        isShiftLabelEdit: false,
        showDeletePCNBtn: false,
        showCreateEditPCNButtons: false,
        leafletPayload: null,
        pcnModalType: 'DEFAULT',
        dataGridList: {
            monday: [] as RouteGridItem[],
            tuesday: [] as RouteGridItem[],
            wednesday: [] as RouteGridItem[],
            thursday: [] as RouteGridItem[],
            friday: [] as RouteGridItem[],
            saturday: [] as RouteGridItem[],
            sunday: [] as RouteGridItem[]
        },
        closeSaveGridModalCallback: function() {
            return; // empty callback as default
        }
    };

    defaultGridValues: {[key: string]: string} = {};
    defaultColumnsDefinition: ColDef[] = [];
    defaultShiftLabel = undefined as { id: number, name: string } | undefined;
    defaultSessionType = undefined as { id: number, name: string } | undefined;
    newRowsCreated: string[] = [];
    isNewVersion = false;
    saveGridModeCallback?: () => void;
    gridApi: GridApi | null = null;
    currentDate = dayjs();
    daysInMonth = this.currentDate.daysInMonth();

    componentDidMount() {
        const {
            rootStore: { managerStore }
        } = this.props;

        const {
            error,
            currentAccount,
            getSessionTypes,
            getShiftLabels
        } = managerStore;

        const schedulingRoutes = currentAccount?.schedulingRoutes as SchedulingRoutesDic | undefined;
        const portal3Tab = schedulingRoutes?.portal3_tab;
        
        if (portal3Tab) {
            this.fetchRunningJobs();

            this.defaultGridValues = portal3Tab.default_grid_values;
            this.defaultColumnsDefinition = portal3Tab.route_columns_definition;
            CC_ROUTES_NAME = portal3Tab?.routes_prefix;
            this.isNewVersion = portal3Tab?.version === 3;

            if (this.isNewVersion) {
                getSessionTypes().then((sessionTypes: SessionTypeParameters[]) => {
                    if (!sessionTypes.length) {
                        return;
                    }

                    this.defaultSessionType = {
                        id: sessionTypes[0].id,
                        name: sessionTypes[0].name
                    };

                    const shiftLabels = sessionTypes[0].shift_labels;

                    this.defaultShiftLabel = {
                        id: shiftLabels[0].id,
                        name: shiftLabels[0].name
                    };

                    const newFrequencies: RouteFrequency[] = sessionTypes.filter(session => session.name === this.defaultSessionType?.name)[0].frequencies;
                    const defaultColumns = this.convertToColumns(this.defaultColumnsDefinition);

                    this.setState({
                        sessionTypes,
                        currentSessionType: this.defaultSessionType,
                        frequencies: newFrequencies,
                        shiftLabels,
                        currentShiftLabel: this.defaultShiftLabel,
                        gridColumns: defaultColumns,
                        dataGridList: {
                            daily: [] as RouteGridItem[],
                            weekdays: [] as RouteGridItem[],
                            weekly: [] as RouteGridItem[],
                            two_weeks: [] as RouteGridItem[],
                            monthly: [] as RouteGridItem[]
                        }
                    });
                });
            } else {
                const defaultColumns = this.convertToColumns(this.defaultColumnsDefinition);
                this.setState({
                    gridColumns: defaultColumns
                });

                getShiftLabels().then((shiftLabels: ShiftLabelParameters[]) => {
                    if (!shiftLabels.length) {
                        return;
                    }

                    this.defaultShiftLabel = {
                        id: shiftLabels[0].id,
                        name: shiftLabels[0].name
                    };
                    this.setState({
                        shiftLabels,
                        currentShiftLabel: this.defaultShiftLabel
                    });
                });
            }

            this.fetchFoldersTree();
        }

        if (error) {
            this.showError(error);
            managerStore.error = '';
        }
    }

    componentDidUpdate(prevProps: Props) {
        const { userTeam: currentUserTeam } = this.props;
        if (currentUserTeam && prevProps.userTeam !== currentUserTeam) {
            this.refreshTeam(currentUserTeam);
        }
    }

    componentWillUnmount() {
        const { runningJobs } = this.state;
        this.clearIntervals(runningJobs);
    }

    clearIntervals(tasks: RunningJobs[]) {
        tasks.forEach((element) => {
            element.set_to_stop = true;
        });
    }

    fetchRunningJobs = () => {
        const {
            rootStore: { managerStore },
        } = this.props;
        const tasks = managerStore.currentStoredJobs.find(e => e.page === MainTabs.Routes);

        if (!tasks) {
            return;
        }

        this.setState({
            runningJobs: tasks.tasks
        }, () => {
            tasks.tasks.forEach(element => {
                if(element.status === 102) {
                    // SET TO RESTART POOLING
                    element.set_to_stop = false;
                    this.startTaskWatcher(element);
                }
            });
        });
    };


    startTaskWatcher = (task: RunningJobs, isReloadPCN = false) => {
        const { runningJobs, currentPcn } = this.state;

        if (!task.task_name || !task.task_id) {
            return;
        }

        const statusCallback = (taskId: string) => {
            const taskIndex = runningJobs.findIndex(e => e.task_id === taskId);
            const taskItem = runningJobs.find(e => e.task_id === taskId);

            if (!taskItem || taskItem.status !== 102) {
                return;
            }

            if (taskItem.set_to_stop) {
                return;
            }

            const {
                rootStore: { managerStore },
            } = this.props;
            
            managerStore.getRunningJobStatus(taskItem.task_id).then(data => {
                const endTime = new Date();
                taskItem.elapsedTime = Math.floor(Math.abs((endTime.getTime() - taskItem.startedAt) / 1000));
                if (data.status === StatusTypes.Error) {
                    taskItem.status = 500;
                    runningJobs[taskIndex] = taskItem;
                }
                if (data.status === StatusTypes.Complete) {
                    taskItem.status = 200;
                    taskItem.progress = 100.0;
                    // Refresh route once grid saving edit/create status is complete
                    if (isReloadPCN && currentPcn) {
                        this.submitPCN(currentPcn);
                    }
                } else {
                    // KEEP TRACK OF THE PROGRESS STATUS IF ITS STILL THE SAME
                    if (taskItem.progress === data.completion) {
                        taskItem.static_progress_count += 1;
                    }
                    taskItem.progress = data.completion;
                    // IF WE REACH A POINT WHERE THE STATUS IS THE SAME THE JOB IS SLOW
                    // MAKE FEWER REQUESTS TO NOT OVERWHELM THE STATUS ENDPOINT
                    if (taskItem.static_progress_count === STATIC_PROGRESS_LIMIT) {
                        taskItem.timer += 1000;
                        taskItem.static_progress_count = 0;
                    }
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    setTimeout(taskItem.internalCallback!, taskItem.timer, taskId);
                }
                managerStore.setCurrentJobs(runningJobs, MainTabs.Routes);
                this.setState({runningJobs});
            }).catch((error) => {
                const { status } = error.response;
                // CHECK IF WE TIMEOUT OR NOT
                if (status === 408 || status === 504) {
                    // WE HAVE TIMEOUT INCREASE TIMER AND KEEP TRYING
                    taskItem.timer += 1000;
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    setTimeout(taskItem.internalCallback!, taskItem.timer, taskId);
                    return;
                }
                taskItem.status = 500;
                runningJobs[taskIndex] = taskItem;
                managerStore.setCurrentJobs(runningJobs, MainTabs.Routes);
                this.setState({runningJobs});
            });
        };

        // PREVENT GENERATING TIMERS WITHOUT PROPERTIES BEING INITIALIZED
        const taskIndex = runningJobs.findIndex(e => e.task_id === task.task_id);
        runningJobs[taskIndex].internalCallback = statusCallback;
        this.setState({runningJobs}, () => {
            this.setState({isRoutesDrawerOpen: true});
            setTimeout(statusCallback, task.timer, task.task_id);
        });
    };

    fetchFoldersTree = () => {
        const {
            rootStore: { managerStore },
            userTeam
        } = this.props;

        managerStore.getAccountFolderTree(FOLDER_PERMISSIONS, userTeam).then(data => {
            this.setState({
                treeFolders: data,
                treeFoldersClicked: [],
                treeFoldersExpanded: []
            });
        }).catch(error => {
            this.showError(error);
        });
    };

    refreshTeam = (userTeam: UserTeam) => {
        const {
            treeFoldersExpanded,
            treeFoldersClicked,
        } = this.state;

        if (userTeam) {
            this.getTeamFolders(userTeam.teamId)
                .then(
                    (
                        results: LocationFilterCallbackTypeWithAccount<Folder>
                    ) => {
                        const { data, total, accountId, accountName } = results;
                        if (data.length) {
                            // Use root node with account data
                            // if children has multiple folders
                            // otherwise user the folder data as root node
                            const treeHasRootNode = total > 1;
                            const treeFolders = {
                                id: treeHasRootNode ? accountId : data[0].id,
                                name: treeHasRootNode ? accountName : data[0].name,
                                children: treeHasRootNode ? [...data] : [],
                            };

                            this.setState({
                                treeFolders: treeFolders,
                                treeFoldersExpanded: treeHasRootNode
                                    ? [...treeFoldersExpanded, accountId]
                                    : treeFoldersExpanded,
                                treeFoldersClicked: treeHasRootNode
                                    ? [...treeFoldersClicked, accountId]
                                    : treeFoldersClicked,
                            });
                        }
                    }
                )
                .catch((error) => {
                    this.showError(
                        `${error} Location filter will be disabled.`
                    );
                });
        }
    };

    getTeamFolders = (
        teamId: string,
        folder: NavigationListItem | undefined = undefined
    ): Promise<LocationFilterCallbackTypeWithAccount<Folder>> => {
        const {
            rootStore: { managerStore },
        } = this.props;
        const foldersTotal =
            folder && folder.folderDataTotal ? folder.folderDataTotal : -1;
        if (foldersTotal > 0 && foldersTotal <= 0) {
            return Promise.resolve({
                data: [],
                total: 0,
                accountName: '',
                accountId: '',
            });
        }

        const folderId = folder ? folder.id : '';
        const { LOCATION_FILTER_BUFFER_LIMIT: BUFFER_LIMIT } = REPORTS;
        return new Promise<LocationFilterCallbackTypeWithAccount<Folder>>(
            (resolve, reject) => {
                managerStore
                    .getTeamFolders(
                        teamId,
                        folderId,
                        BUFFER_LIMIT
                    )
                    .then(
                        (
                            teamFolderResults: SearchResultsWithAccount<Folder>
                        ) => {
                            const {
                                rows: folders,
                                accountId,
                                accountName,
                                meta: { totalCount: total },
                            } = teamFolderResults;

                            const results = {
                                data: folders,
                                accountId,
                                accountName,
                                total,
                            } as LocationFilterCallbackTypeWithAccount<Folder>;

                            resolve(results);
                        }
                    )
                    .catch((error) => {
                        return reject(error);
                    });
            }
        );
    };

    showSnackbar = (
        snackbarMessage: string,
        snackbarVariant: CCSnackbarVariant
    ) => {
        this.setState({
            snackbarVariant,
            snackbarMessage,
            snackbarOpen: true,
        });
    };

    showError = (errorMessage: string | undefined) => {
        let message;
        if (errorMessage) {
            message = errorMessage;
        } else {
            message = 'Unknown Error';
        }

        this.showSnackbar(message, 'error' as CCSnackbarVariant);
    };

    showWarning = (warningMessage: string | undefined) => {
        if (!warningMessage) {
            return;
        }

        this.showSnackbar(warningMessage, 'warning' as CCSnackbarVariant);
    };

    showDialog = (dialogTitle: string, dialogMessage: string) => {
        this.setState({
            dialogTitle,
            dialogMessage,
            dialogOpen: true
        });
    };

    onSnackbarClosed = () => {
        this.setState({ snackbarOpen: false });
    };

    onDialogClosed = () => {
        this.setState({ dialogOpen: false });
    };

    onToggleSideNavBar = () => {
        const { isRoutesDrawerOpen } = this.state;
        this.setState({ isRoutesDrawerOpen: !isRoutesDrawerOpen});
    };

    onSelectFolder = (selectedFolder: EntityFolder) => {
        const {
            rootStore: { 
                managerStore
            },
            userTeam
        } = this.props;

        if (!selectedFolder) {
            this.showWarning("The selected folder doesn't exist");
            return;
        }

        managerStore.getUserPermissions(selectedFolder.folder_id, userTeam).then((response: UserPermissions) => {
            const { permissions } = response;
            const createEditPermission = permissions.includes('route_write');

            this.setState({
                showDeletePCNBtn: permissions.includes('route_delete'),
                showCreateEditPCNButtons: createEditPermission,
                gridRows: [],
                isPreviewGridMode: false,
                isCreateNewRoute: false
            });

            this.openPCNModal(selectedFolder, createEditPermission ? MODAL_TYPE.DEFAULT : MODAL_TYPE.LIST);
        }).catch((error) => {
            this.showError(error);
        });
    };

    createOtherPCN = () => {
        const { selectedFolder, isGridUpdated } = this.state;

        const openModal = () => {
            this.openPCNModal(selectedFolder as EntityFolder, MODAL_TYPE.NEW);
        };

        if (isGridUpdated) {
            this.showSaveGridModal(openModal);
            return;
        }

        openModal();
    };

    showPCNList = () => {
        const { selectedFolder, isGridUpdated } = this.state;

        const openModal = () => {
            this.openPCNModal(selectedFolder as EntityFolder, MODAL_TYPE.LIST);
        };

        if (isGridUpdated) {
            this.showSaveGridModal(openModal);
            return;
        }

        openModal();
    };

    openPCNModal = (selectedFolder: EntityFolder, pcnModalType = MODAL_TYPE.DEFAULT) => {
        const { currentShiftLabel, currentSessionType } = this.state;
        const defaultProperties = {
            selectedFolder,
            pcnModalType,
            isPcnModalOpen: true,
            pcnField: '',
            currentShiftLabel: currentShiftLabel ? currentShiftLabel : this.defaultShiftLabel,
            currentSessionType: currentSessionType ? currentSessionType : this.defaultSessionType,
            frequencies: [],
            pcnOffset: 0
        };

        if (pcnModalType === MODAL_TYPE.NEW) {
            this.setState(defaultProperties);
            return;
        }

        // Update the current routes list to default
        this.updatePCNList(selectedFolder?.folder_id, 0).then(() => {
            this.setState(defaultProperties);
        }).catch((error) => {
            this.showError(error);
        });
    };

    onClosePCNModal = () => {
        this.setState({
            isPcnModalOpen: false,
            pcnModalType: MODAL_TYPE.DEFAULT
        });
    };

    updatePCNList = (folderId?: string, offset?: number): Promise<void> => {
        const {
            rootStore: { 
                managerStore
            },
            userTeam
        } = this.props;

        const { pcnOffset } = this.state;
        const { PCN_ROUTES_RECORD_LIMIT } = PCN_ROUTES;
        const currentOffset = offset !== undefined ? offset : pcnOffset;

        return managerStore.getPCNList(
            PCN_ROUTES_RECORD_LIMIT,
            currentOffset,
            { folder_id: folderId },
            userTeam
        ).catch((error) => {
            this.showError(error);
        });
    };

    convertPCNRoutesIntoListItems = memoize(
        (rows: PCNList[]): SimpleListItem[] => {
            return rows.map((item: PCNList) => {
                const {
                    folder_doc_id,
                    id,
                    value,
                    shift_label: shift_label_name,
                    shift_label_id,
                    session_type_name,
                    session_type_id,
                    frequencies
                } = item;

                const shiftLabelData = {
                    id: shift_label_id,
                    name: shift_label_name
                };

                const data: {
                    pcnId: string;
                    pcnValue: string;
                    shiftLabel: {
                        id: number;
                        name: string;
                    };
                    sessionType?: {
                        id: number;
                        name: string;
                    };
                    frequencies: string[]
                } = {
                    pcnId: id,
                    pcnValue: value,
                    shiftLabel: shiftLabelData,
                    frequencies: frequencies ? frequencies.map((item) => { return JSON.stringify(item); }) : [] as string[]
                };

                if (this.isNewVersion) {
                    data.sessionType = {
                        id: session_type_id as number,
                        name: session_type_name as string
                    };
                }

                const secondaryLabel = this.isNewVersion ? `${session_type_name} - ${shift_label_name}` : shift_label_name;

                return new SimpleListItem(
                    `pcn_${folder_doc_id}_${id}`,
                    value, secondaryLabel,
                    undefined, undefined, undefined,
                    data);
            });
        }
    );

    convertToRows = (routes: ScheduleRow[]) => {
        const {
            rootStore: { 
                managerStore: {
                    folderMarkers
                }
            }
        } = this.props;

        const { gridColumns, selectedPcn, frequencies } = this.state;
        const { pcnId, defaultFrequency } = selectedPcn as EntityPCN;

        const markerRoute: {[key: string]: ScheduleRow[] } = {};
        routes.map((route) => {
            const markerIdFormatted = `${route.markerId}`.replace('marker::', '');
            if (markerIdFormatted in markerRoute) {
                markerRoute[markerIdFormatted] = [...markerRoute[markerIdFormatted], route];
            } else {
                markerRoute[markerIdFormatted] = [route];
            }
        });

        const fields = {} as { [key:string]: string | boolean };
        const defaultColumnFields = Object.keys(this.defaultGridValues);
        gridColumns.map((columnField) => {
            const { field } = columnField;

            if (!field) {
                return;
            }

            const isWeekday = WEEKDAYS.filter(weekday => weekday === field).length;
            // Set default cell values
            if (defaultColumnFields.includes(field)) {
                // Set the default value from account meta
                fields[field] = this.defaultGridValues[field];
            } else if (isWeekday || field === 'rowSelected') {
                // Set unchecked for the weekdays
                fields[field] = false;
            } else if (field === 'frequency' && frequencies.length) {
                // Set first value for frequency field if default frequency doesn't exist
                fields[field] = defaultFrequency ? defaultFrequency : frequencies[0].value;
            } else {
                // Set an empty string for the others
                fields[field] = '';
            }
        });

        let rows: ValidAgGridRowModel[] = [];
        folderMarkers.map((marker) => {
            const {id: markerId, name: markerName, floorplanName, meta} = marker;
            let rowItems: {[key: string]: string | boolean | number}[] = [];

            if (markerId in markerRoute) {
                rowItems = markerRoute[markerId].map((row) => {
                    return {...fields, ...row};
                });
            } else {
                rowItems = [{...fields, markerId:`marker::${markerId}`, markerName, floorplanName}];
            }

            rowItems.map((rowItem) => {
                if (this.isNewVersion && meta && meta?.type) {
                    rowItem['markerType'] = meta.type;
                }

                for (const key in rowItem) {
                    if (rowItem.hasOwnProperty(key)) {
                        // Set the right boolean for weekdays or rowSelected fields
                        const isWeekday = WEEKDAYS.filter(weekday => weekday === key).length;
                        if (isWeekday || key === 'rowSelected') {
                            rowItem[key] = rowItem[key] || `${rowItem[key]}` === `${pcnId}` ? true : false;
                        }
                    }
                }

                rows = [...rows, rowItem];
            });
        });

        // Set id column for grid
        const gridRows = rows.map((row, index) => {
            return {id: index, ...row};
        });

        const totalSelectedRows = routes.filter((row) => {
            if (this.isNewVersion) {
                if (row.rowSelected) {
                    return true;
                }
            } else {
                for (const day of WEEKDAYS) {
                    if (row[day]) {
                        return true;
                    }
                }
            }

            return false;
        });

        const totalSelectedMarkers: string[] = [];
        totalSelectedRows.map((row) => {
            const { markerId } = row;
            if (!totalSelectedMarkers.includes(`${markerId}`)) {
                totalSelectedMarkers.push(`${markerId}`);
            }
        });

        this.setState({
            gridRows: gridRows,
            initialGridRows: JSON.stringify(gridRows),
            totalMarkers: totalSelectedMarkers.length
        });
    };

    getFolderNodes = (
        teamId: string,
        folderId: string
    ): Promise<RenderTree[]> => {
        const { LOCATION_FILTER_BUFFER_LIMIT: BUFFER_LIMIT } = REPORTS;
        const {
            rootStore: { managerStore },
        } = this.props;
        return managerStore
            .getFolderFloorplans(teamId, folderId, BUFFER_LIMIT)
            .then((results: SearchResults<Floorplan>) => {
                const {
                    rows: floorplans,
                    meta: { totalCount: totalFloorplans },
                } = results;

                if (totalFloorplans) {
                    return floorplans.map((floorplan: Floorplan) => {
                        // Add prefix to differentiate floorplans
                        // from the rest of the folder nodes
                        return {
                            id: `floorplan::${floorplan.id}`,
                            name: floorplan.name,
                        };
                    });
                } else {
                    this.showWarning(
                        'There are no folders or floorplans associated to this folder'
                    );
                    return [] as RenderTree[];
                }
            });
    };

    findNodeById = (root: RenderTree | null, id: string): RenderTree | null => {
        if (!root) return null;
    
        if (root.id === id) {
            return root;
        }
    
        if (root.children) {
            for (const child of root.children) {
                const foundNode = this.findNodeById(child, id);
                if (foundNode) {
                    return foundNode;
                }
            }
        }
    
        return null;
    };
    
    findChildrenById = (root: RenderTree | null, id: string): RenderTree[] => {
        const parentNode = this.findNodeById(root, id);
        if (parentNode && parentNode.children) {
            return parentNode.children;
        }
        return [];
    };

    onFolderTreeClick = async (folderId: string): Promise<RenderTree[]> => {
        const { userTeam } = this.props;
        const { treeFoldersClicked, treeFolders } = this.state;
        
        let folderNodes = [] as RenderTree[];

        if (userTeam) {
            folderNodes = this.findChildrenById(treeFolders, folderId);

            if (folderNodes.length <= 0) {
                folderNodes = await this.getFolderNodes(userTeam.teamId, folderId);
            }
        }

        this.setState({
            treeFoldersClicked: [...treeFoldersClicked, folderId],
        });

        return folderNodes;
    };

    onFolderTreeToggle = (folderIds: string[]) => {
        this.setState({ treeFoldersExpanded: folderIds });
    };

    onGridSaved = () => {
        const {
            rootStore: { managerStore },
            userTeam
        } = this.props;

        const { currentPcn, selectedPcn, gridRows, dataGridList, frequencies } = this.state;
        const { pcnId } = selectedPcn as EntityPCN;
        const gridDataUpdated: RouteGridList = {...dataGridList as RouteGridList};
        let isSelectedRowUnassigned = false;

        for (const row of gridRows) {
            if (isSelectedRowUnassigned) {
                break;
            }
            const {
                markerId,
                markerName,
                moduleGroup,
                moduleGroupId,
                floorplanName,
                frequency: rowFrequency,
                rowSelected,
                days,
                id: rowId
            } = row;

            const LIST = this.isNewVersion ? frequencies.map(f => f.value) : WEEKDAYS;
            const selectedFrequency = frequencies.filter(frequency => frequency.value === rowFrequency)[0];
            for (const item of LIST) {
                const conditional = this.isNewVersion ?
                    rowFrequency === item && rowSelected === true :
                    row[item] === true;

                if (conditional) {
                    if (this.isNewVersion && (moduleGroupId === '' ||  (days === '' && selectedFrequency.allow_days))) {
                        isSelectedRowUnassigned = true;
                        break;
                    }
                    
                    if (!this.isNewVersion && moduleGroupId === '') {
                        isSelectedRowUnassigned = true;
                        break;
                    }

                    gridDataUpdated[item as keyof RouteGridList] = [...(gridDataUpdated[item as keyof RouteGridList] || []), {
                        marker_doc_id: markerId,
                        marker_name: markerName,
                        module_group_name: moduleGroup,
                        module_group_doc_id: moduleGroupId,
                        floorplan_name: floorplanName,
                        row_id: rowId,
                        days: this.isNewVersion && days !== '' ? `${days}`.split(',') : []
                    } as RouteGridItem];
                }
            }
        }

        if (isSelectedRowUnassigned) {
            this.showDialog(
                `Error Saving Route`,
                `Categories or required days are missing at one or some rows, please review the selected rows`
            );
            return;
        }

        // UPDATE SCHEDULE
        managerStore.createScheduleRoute(gridDataUpdated, Number(pcnId), userTeam).then((response) => {
            const { selectedFolder, runningJobs } = this.state;
            const { jobId } = response;

            const newJob: RunningJobs = {
                task_name: selectedFolder ? selectedFolder.folder_name : 'Creating route',
                task_id: jobId,
                status: 102,
                type: JobTypes.RouteCreation,
                startedAt: Date.now(),
                elapsedTime: 0,
                progress: 0,
                timer: 1500,
                static_progress_count: 0,
                set_to_stop: false,
                result_data: selectedFolder
            };

            runningJobs.push(newJob);
            managerStore.setCurrentJobs(runningJobs, MainTabs.Routes);
            this.startTaskWatcher(newJob, true);

            // Convert to grid rows after save
            this.convertToRows(gridRows as ScheduleRow[]);

            this.setState({
                isPreviewGridMode: true,
                isNewSchedule: false,
                isGridUpdated: false,
                runningJobs
            });

            if (this.saveGridModeCallback) {
                this.saveGridModeCallback();
            }

            this.showDialog(`Route Saved`, `Route ${currentPcn} is updated successfully`);
        }).catch((error) => {
            this.showError(error);
        });
    };

    onGridChanged = (params: CellValueChangedEvent, saveGridModeCallback: () => void) => {
        const { initialGridRows } = this.state;

        if (!this.saveGridModeCallback) {
            this.saveGridModeCallback = saveGridModeCallback;
        }

        const current: ValidAgGridRowModel[] = [];
        params.api.forEachNode(node => current.push(node.data));
        const isChanged = JSON.stringify(current) !== initialGridRows;

        this.setState({ isGridUpdated: isChanged });
    };

    onGridExport = () => {
        if (!this.gridApi) {
            this.showError('Grid is not loaded yet, please try again later');
            return;
        }

        const { currentPcn } = this.state;
        
        this.gridApi.exportDataAsExcel(
            {
                shouldRowBeSkipped: (params) => {
                    return this.isNewVersion ? !params.node.data.rowSelected : WEEKDAYS.filter(weekday => params.node.data[weekday]).length === 0;
                },
                fileName: `${currentPcn}.xlsx`
            }
        );
    };

    onGridReady = (params: GridReadyEvent) => {
        this.gridApi = params.api;
    };

    showSaveGridModal = (closeSaveGridModalCallback: () => void) => {
        this.setState({
            openSaveGridModal: true,
            closeSaveGridModalCallback
        });
    };

    onGridSaveModal = (type: number) => {
        const { closeSaveGridModalCallback, initialGridRows } = this.state;

        this.setState({
            openSaveGridModal: false
        }, () => {
            if (type === 1) {
                this.onGridSaved();
            } else {
                const gridRows = JSON.parse(initialGridRows) as ValidAgGridRowModel[];
                this.setState({ gridRows, isGridUpdated: false }, () => {
                    closeSaveGridModalCallback();
                });
            }
        });
    };

    onEditPCNModal = () => {
        const {
            rootStore: { managerStore },
            userTeam
        } = this.props;
        const {
            selectedPcn,
            selectedFolder,
            currentShiftLabel,
            pcnField,
            isShiftLabelEdit,
            runningJobs
        } = this.state;
        const { folder_id } = selectedFolder as EntityFolder;
        const { pcnId, pcnValue } = selectedPcn as EntityPCN;
        const newShiftType = this.isNewVersion ? currentShiftLabel?.id : currentShiftLabel?.name;
        const newShiftLabel = isShiftLabelEdit ? newShiftType : undefined;
        const newPcnValue = !isShiftLabelEdit && pcnField !== '' ? pcnField : undefined;

        managerStore.editSchedulePcn(pcnId, folder_id, newPcnValue, newShiftLabel, userTeam).then((response) => {
            if (!isShiftLabelEdit) {
                const { jobId, message } = response as JobCreationResult;
                const newJob: RunningJobs = {
                    task_name: `Editing ${pcnValue}`,
                    task_id: jobId,
                    status: 102,
                    type: JobTypes.PCNEdition,
                    startedAt: Date.now(),
                    elapsedTime: 0,
                    progress: 0,
                    timer: 1500,
                    static_progress_count: 0,
                    set_to_stop: false,
                    result_data: selectedPcn
                };

                // SEND PCN DELETION TO JOB
                runningJobs.push(newJob);
                managerStore.setCurrentJobs(runningJobs, MainTabs.Routes);
                this.startTaskWatcher(newJob);

                this.showDialog(`Route Edited`, message);
                this.onBackToFoldersClicked();
            } else {
                this.showDialog(`Shift Label Edited`, response as string);
            }

            this.onCloseEditPCNModal();
        }).catch((error) => {
            this.showDialog('ERROR', error);
        });
    };

    onCloseEditPCNModal = () => {
        this.setState({ isOpenEditPCNModal: false, isShiftLabelEdit: false });
    };

    moduleGroupCellRenderer = (props: CustomCellRendererProps) => {
        const { 
            classes,
            rootStore: {
                managerStore: {
                    schedulesModuleGroups
                }
            }
        } = this.props;
        const { gridRows } = this.state;
        const { 
            data: rowData,
            api: { startEditingCell },
            node,
            column,
            setValue
        } = props;

        const { markerId, moduleGroupId, id: rowId } = rowData;
        const rowIndex = node.rowIndex!;

        // Render first option value when marker has a single module group option
        if (schedulesModuleGroups[markerId].length === 1 && setValue && (!moduleGroupId || moduleGroupId === '')) {
            const firstOption = schedulesModuleGroups[markerId][0];
            const { name: firstName, id: firstId } = firstOption;
            node.setDataValue('moduleGroupId', firstId);
            setValue(firstName);

            this.setState({
                initialGridRows: JSON.stringify(gridRows)
            });
        }

        const editModuleGroup = () => {
            startEditingCell({
                rowIndex,
                colKey: column!.getId(),
            });
        };

        const addModuleGroup = () => {
            const { gridRows } = this.state;
            const newRow = {
                ...rowData,
                friday: false,
                monday: false,
                saturday: false,
                sunday: false,
                thursday: false,
                tuesday: false,
                wednesday: false,
                rowSelected: false
            };

            const gridRowsUpdated: ValidAgGridRowModel[] = [];
            gridRows.map((row, index) => {
                if (row.id as number < rowId) {
                    gridRowsUpdated.push({ ...row, id: index });
                } else if (row.id === rowId) {
                    gridRowsUpdated.push({ ...row, id: index });
                    gridRowsUpdated.push({ ...newRow, id: index + 1 });
                } else {
                    gridRowsUpdated.push({ ...row, id: index + 1 });
                }
            });

            // Add marker id to the new rows list
            this.newRowsCreated.push(markerId);

            this.setState({
                gridRows: [...gridRowsUpdated]
            });
        };

        const deleteModuleGroup = () => {
            const { gridRows, initialGridRows } = this.state;
            const duplicatedRowIndex = this.newRowsCreated.indexOf(markerId);
            // Check if marker has multiple rows or is a single row
            if (duplicatedRowIndex !== -1) {
                // If marker has multiple rows remove the entire row from the grid
                const filteredRows = gridRows.filter((row) => {
                    return row.id !== rowId;
                });

                const gridRowsUpdated = filteredRows.map((row, index) => {
                    return {...row, id: index};
                });

                this.setState({
                    gridRows: [...gridRowsUpdated]
                });

                this.newRowsCreated.splice(duplicatedRowIndex, 1);
                return;
            }

            // If marker is a single row just delete the values
            node.setDataValue('rowSelected', false);
            WEEKDAYS.map((day) => {
                node.setDataValue(day, false);
            });

            // Delete module group values if marker has multiple module group options
            if (setValue && schedulesModuleGroups[markerId].length > 1) {
                setValue('');
                node.setDataValue('moduleGroupId', '');
            }

            const isChanged = JSON.stringify(gridRows) !== initialGridRows;

            if (isChanged) {
                this.setState({ isGridUpdated: true });
            } else {
                this.setState({ isGridUpdated: false });
            }
        };

        return (
            <div className={classes.editCell}>
                {
                    props.colDef && props.colDef.editable ?
                        <>  
                            <div className={classes.dropdownGrid}>
                                <span>{props.value}</span>
                                <IconButton
                                    aria-label="edit"
                                    onClick={editModuleGroup}
                                    color='primary'
                                >
                                    <ArrowDropDownIcon />
                                </IconButton>
                            </div>
                            <div>
                                <IconButton
                                    aria-label="add"
                                    onClick={addModuleGroup}
                                    color='primary'
                                >
                                    <AddIcon />
                                </IconButton>
                                <IconButton
                                    aria-label="delete"
                                    onClick={deleteModuleGroup}
                                    color='primary'
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </div>
                        </>
                        : <>
                            {props.value}
                        </>
                }
            </div>
        );
    };

    moduleGroupCellEditor = (props: CustomCellEditorProps) => {
        const { frequencies } = this.state;
        const { 
            classes,
            rootStore: {
                managerStore: {
                    schedulesModuleGroups
                }
            }
        } = this.props;

        const {
            onValueChange,
            stopEditing,
            data: rowData,
            node
        } = props;
        const { markerId } = rowData;
         
        const moduleChange = (event: SelectChangeEvent<string>) => {
            const selectedValue = event.target.value;
            const { name, id } = JSON.parse(selectedValue);
            // Update the module group Id cell
            const moduleGroupId = `module_group::${id.replace('module_group::', '')}`;
            node.setDataValue('moduleGroupId', moduleGroupId);

            // Check if frequency has auto select to select row
            // TODO - Remove hard code conditional once auto_select flag is set
            if (this.isNewVersion && 'frequency' in rowData) {
                const selectedFrequency = frequencies.filter((frequency: RouteFrequency) => frequency.value === rowData['frequency']);

                if (selectedFrequency.length && selectedFrequency[0]?.auto_select) {
                    node.setDataValue('rowSelected', true);
                }
            }

            // Update the module group name cell
            onValueChange(name);
            stopEditing();
        };

        return (
            <FormControl size="small" fullWidth>
                <Select
                    displayEmpty
                    value={''}
                    onChange={moduleChange}
                    className={classes.moduleGroupSelector}
                    defaultOpen={true}
                >
                    {
                        schedulesModuleGroups[markerId].map((value: ScheduleRow, index: number) => {
                            const { name, id } = value;
                            const selectedValue = JSON.stringify({name, id});
                            return (
                                <MenuItem key={index} value={selectedValue}>
                                    {name}
                                </MenuItem>
                            );
                        })
                    }
                </Select>
            </FormControl>
        );
    };

    frequenciesCellEditor = (props: CustomCellEditorProps) => {
        const { frequencies } = this.state;
        const { classes } = this.props;
        const {
            onValueChange,
            stopEditing,
            node
        } = props;

        const frequencyChange = (event: SelectChangeEvent<string>) => {
            const selectedValue = event.target.value;
            const selectedFrequency = frequencies.filter((frequency: RouteFrequency) => frequency.value === selectedValue);

            if (!selectedFrequency.length) {
                this.showWarning(`The selected frequency is no included into session type - ${selectedValue}`);
                onValueChange(selectedValue);
                stopEditing();
                return;
            }

            // Set the default days value when changing to daily frequency
            if (selectedValue === 'daily') {
                const weekdays = selectedFrequency[0].selectable_days.length
                    ? selectedFrequency[0].selectable_days.toString()
                    : WEEKDAYS.toString();
                node.setDataValue('days', weekdays);
            } else {
                node.setDataValue('days', '');
            }

            // Update cell
            onValueChange(selectedValue);
            stopEditing();
        };

        return (
            <FormControl size="small" fullWidth>
                <Select
                    displayEmpty
                    value={''}
                    onChange={frequencyChange}
                    className={classes.frequencySelector}
                    defaultOpen={true}
                >
                    {
                        frequencies.map((frequency: RouteFrequency, index: number) => {
                            const { name, value } = frequency;
                            return (
                                <MenuItem key={index} value={value}>
                                    {name}
                                </MenuItem>
                            );
                        })
                    }
                </Select>
            </FormControl>
        );
    };

    frequenciesRender = (props: CustomCellRendererProps) => {
        const { frequencies } = this.state;
        const { value } = props;
        const selectedFrequency = frequencies.filter((frequency: RouteFrequency) => frequency.value === value);
        return <div>{selectedFrequency.length ? selectedFrequency[0].name : value}</div>;
    };

    daysCellEditor = (props: CustomCellEditorProps) => {
        const { frequencies } = this.state;
        const { classes } = this.props;
        const {
            value: daysValue,
            data: rowData,
            onValueChange,
            stopEditing
        } = props;

        const selectedDays = daysValue !== '' ? daysValue.split(',') as string[] : [];
        const frequencyValue = rowData['frequency'];
        const selectedFrequency = frequencies.filter((frequency: RouteFrequency) => frequency.value === frequencyValue);

        if (!selectedFrequency.length) {
            return <div>Error: Frequency {frequencyValue} not match</div>;
        }

        const isAllowDays = selectedFrequency[0].allow_days;
        const summary = selectedFrequency[0].summary;

        if (!isAllowDays) {
            return <div className={classes.noDaysEditor}>{summary}</div>;
        }

        const dayList = selectedFrequency[0].selectable_days.length
            ? selectedFrequency[0].selectable_days.map(day => `${day}`)
            : WEEKDAYS;

        let isWeekDays = false;
        for (const day of WEEKDAYS) {
            if (dayList.includes(day)) {
                isWeekDays = true;
                break;
            }
        }

        return (
            <>
                {
                    // Display weekdays widget if days are from monday to friday
                    isWeekDays ?
                        <div className={classes.daysEditor}>
                            {
                                dayList.map((day) => {
                                    const isSelected = selectedDays.includes(day);
                                    return (
                                        <FormControlLabel
                                            key={day}
                                            style={{ textTransform: 'capitalize' }}
                                            label={day.substring(0, 3)}
                                            control={
                                                <Checkbox
                                                    checked={isSelected}
                                                    onChange={() => {
                                                        const newSelectedDays = isSelected ? selectedDays.filter(d => d !== day) : [...selectedDays, day];
                                                        const sortedDays = newSelectedDays.sort((a: string, b: string) => WEEKDAYS.indexOf(a) - WEEKDAYS.indexOf(b));
                                                        onValueChange(sortedDays.toString());
                                                    }}
                                                />
                                            }
                                        />
                                    );
                                })
                            }
                            <Divider />
                            <div className={classes.daysEditorButtons}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => {
                                        onValueChange(dayList.toString());
                                    }}
                                >
                                    Select All
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => {
                                        onValueChange('');
                                    }}
                                >
                                    Clear
                                </Button>
                                <IconButton
                                    aria-label="close"
                                    color='primary'
                                    onClick={() => {
                                        stopEditing();
                                    }}
                                >
                                    <CancelIcon />
                                </IconButton>
                            </div>
                        </div>
                        // Display monthly days widget if days are numbers
                        : <div className={classes.daysEditor}>
                            <div className={classes.daysEditorTitle}>
                                <Typography
                                    variant="h5"
                                >
                                    Select Days
                                </Typography>
                                <IconButton
                                    aria-label="close"
                                    color='primary'
                                    onClick={() => {
                                        stopEditing();
                                    }}
                                >
                                    <CancelIcon />
                                </IconButton>
                            </div>
                            <Divider />
                            {
                                dayList.map((day, index) => {
                                    const isSelected = selectedDays.includes(day);
                                    return (
                                        <FormControlLabel
                                            className={classes.monthlyDays}
                                            key={index}
                                            label={day}
                                            control={
                                                <Checkbox
                                                    icon={<CircleOutlinedIcon fontSize="large" />}
                                                    checkedIcon={<CircleRoundedIcon fontSize="large" />}
                                                    checked={isSelected}
                                                    disabled={Number(day) < 1 || Number(day) > this.daysInMonth}
                                                    onChange={() => {
                                                        const newSelectedDays = isSelected ? selectedDays.filter(d => d !== day) : [...selectedDays, day];
                                                        const sortedDays = newSelectedDays.map(day => day).sort((a: string, b: string) => Number(a) - Number(b));
                                                        onValueChange(sortedDays.toString());
                                                    }}
                                                />
                                            }
                                        />
                                    );
                                })
                            }
                        </div>
                }
            </>
        );
    };

    selectedDaysRender = (props: CustomCellRendererProps) => {
        const { frequencies, gridRows } = this.state;
        const {
            value: daysValue,
            data: rowData,
            setValue
        } = props;

        const frequencyValue = rowData['frequency'];
        const selectedFrequency = frequencies.filter((frequency: RouteFrequency) => frequency.value === frequencyValue);

        // Set the default days value if frequency si daily
        if (selectedFrequency.length && frequencyValue === 'daily' && setValue) {
            const weekdays = selectedFrequency[0].selectable_days.length
                ? selectedFrequency[0].selectable_days.toString()
                : WEEKDAYS.toString();
            setValue(weekdays);

            this.setState({
                initialGridRows: JSON.stringify(gridRows)
            });
        }

        const selectedDays = daysValue && daysValue !== '' ? daysValue.split(',') as string[] : [];

        return (
            <div style={{ textTransform: 'capitalize' }}>
                {selectedDays.map(day => day.substring(0, 3)).join(', ')}
            </div>
        );
    };

    convertToColumns = (gridColumns: ColDef[]) => {
        const updatedColumns = gridColumns.map((column) => {
            const { field } = column;
            const isWeekday = WEEKDAYS.filter(weekday => weekday === field).length;
            let columnUpdated = {
                ...column,
                cellDataType: 'text'
            };
            // Convert the weekdays columns on checkboxes cell editor
            if (isWeekday) {
                columnUpdated = {...columnUpdated,
                    cellEditor: 'agCheckboxCellEditor',
                    maxWidth: 150,
                    sortable: false,
                    cellDataType: 'boolean'
                };
            }

            switch(field) {
                case 'rowSelected':
                    columnUpdated = {
                        ...columnUpdated,
                        lockPosition: 'right',
                        cellEditor: 'agCheckboxCellEditor',
                        maxWidth: 75,
                        minWidth: 50,
                        sortable: false,
                        cellDataType: 'boolean',
                        cellClass: 'row-selected-cell'
                    };
                    break;
                case 'markerName':
                case 'floorplanName':
                    // Spanning rows for markerName and floorplanName
                    columnUpdated = {
                        ...columnUpdated,
                        spanRows: ({ valueA, valueB }: {valueA: string, valueB: string}) => valueA === valueB
                    };
                    break;
                case 'moduleGroup':
                    // Add custom render edition to module group column
                    columnUpdated = {
                        ...columnUpdated,
                        minWidth: 230,
                        singleClickEdit: false,
                        suppressPaste: true,
                        sortable: false,
                        cellEditor: this.moduleGroupCellEditor,
                        cellRenderer: this.moduleGroupCellRenderer,
                    };
                    break;
                case 'frequency':
                    columnUpdated = {
                        ...columnUpdated,
                        singleClickEdit: true,
                        suppressPaste: true,
                        sortable: false,
                        cellRenderer: this.frequenciesRender,
                        cellEditor: this.frequenciesCellEditor
                    };
                    break;
                case 'days':
                    columnUpdated = {
                        ...columnUpdated,
                        singleClickEdit: true,
                        suppressPaste: true,
                        cellEditorPopup: true,
                        sortable: false,
                        cellRenderer: this.selectedDaysRender,
                        cellEditor: this.daysCellEditor
                    };
                    break;
            }

            return columnUpdated;
        });

        return updatedColumns;
    };

    onBackToFoldersClicked = () => {
        const { isGridUpdated } = this.state;

        if (isGridUpdated) {
            this.showSaveGridModal(this.onBackToFoldersClicked);
            return;
        }

        this.setState({
            isCreateNewRoute: false,
            isPcnModalOpen: false,
            selectedFolder: undefined,
            selectedPcn: undefined,
            users: [] as SearchResultsUser[],
            currentPcn: '',
            selectedFloorplan: undefined,
            isMapsSectionOpen: false,
            isPreviewGridMode: false
        });

    };

    onJobsDataPageOverBoundaryReached = (boundary: PageBoundary, nextPage: number): Promise<void> => {
        return new Promise<void>(() => {
            const { 
                currentJobsOffset,
                runningJobs
            } = this.state;
            const totalTasks = runningJobs.length;
            const isFirstPage = nextPage === 0;
            const isLastPage = nextPage === (Math.ceil(totalTasks / TASKS_ROWS_PER_PAGE)-1);
            const newOffset = isFirstPage ? 0
                : isLastPage ? TASKS_PAGING_LIMIT * Math.floor(totalTasks / TASKS_PAGING_LIMIT)
                    : (boundary === PageBoundary.Upper) ? 
                        currentJobsOffset+TASKS_PAGING_LIMIT :
                        currentJobsOffset-TASKS_PAGING_LIMIT;
            const nextTasks = runningJobs;
            // MANUAL OFFSET
            this.setState({
                runningJobs: nextTasks.splice(newOffset, nextTasks.length)
            });
        });
    };

    onJobClear = () => {
        const { runningJobs } = this.state;
        const pendingTasks = runningJobs.filter(e => e.status === 102);
        const {
            rootStore: { managerStore }
        } = this.props;
        managerStore.setCurrentJobs(pendingTasks, MainTabs.Routes);
        this.setState({runningJobs: pendingTasks});
    };

    onJobClick = (job: RunningJobs) => {
        if (job.status === 102 || job.status === 200) {
            return;
        }

        const {
            rootStore: { managerStore }
        } = this.props;
        managerStore.getRunningJobError(job.task_id)
            .then((response) => {
                this.showDialog(`An error occurred creating a route for ${job.task_name}`, response.error);
            }).catch((error) => {
                this.showError(
                    `Unexpected error ocurred creating route - ${error}`
                );

            });
    };

    submitPCN = (currentPcn: string) => {
        const {
            rootStore: { 
                managerStore
            },
            userTeam
        } = this.props;
        const {
            gridColumns: currentGridColumns,
            selectedPcn,
            selectedFolder,
            isNewSchedule,
            currentShiftLabel,
            currentSessionType,
            frequencies: currentFrequencies
        } = this.state;

        const { folder_id } = selectedFolder as EntityFolder;

        this.setState({ isCreateNewRoute: false, isGridUpdated: false, pcnField: '' });

        managerStore.getFolderMarkers(folder_id).then(() => {
            if (isNewSchedule && currentPcn && currentShiftLabel) {
                // CREATE NEW ROUTE
                managerStore.createSchedulePcn(
                    currentPcn,
                    folder_id,
                    currentShiftLabel,
                    currentSessionType,
                    userTeam
                ).then((selectedPcn: EntityPCN) => {
                    const { frequencies, defaultFrequency, pcnId } = selectedPcn;
                    managerStore.getScheduleModulesGroup(folder_id, this.isNewVersion ? pcnId : '', userTeam).then(() => {
                        const fields = {} as { [key:string]: string | boolean };
                        // Start columns as editable mode with default values from account meta
                        const columns = currentGridColumns.map((columnField) => {
                            const { field } = columnField;

                            fields[field!] = field! in this.defaultGridValues ? this.defaultGridValues[field!] : false;

                            if(!Object(columnField).hasOwnProperty('editable')) {
                                columnField.editable = true;
                            }

                            if (Object(columnField).hasOwnProperty('editable') && columnField['editable']) {
                                columnField.editable = true;
                            }

                            return columnField;
                        });

                        const rows = managerStore.folderMarkers.map((marker, index) => {
                            const {id: markerId, name: markerName, floorplanName, meta} = marker;

                            if (this.isNewVersion && frequencies && frequencies.length) {
                                return {
                                    id: index,
                                    ...fields,
                                    markerId:`marker::${markerId}`,
                                    markerName,
                                    floorplanName,
                                    frequency: defaultFrequency ? defaultFrequency : frequencies[0].value,
                                    markerType: meta && meta?.type ? meta.type : fields['markerType']
                                };
                            }

                            return {
                                id: index,
                                ...fields,
                                markerId:`marker::${markerId}`,
                                markerName,
                                floorplanName
                            };
                        });

                        this.setState({
                            isCreateNewRoute: true,
                            gridRows: rows,
                            initialGridRows: JSON.stringify(rows),
                            gridColumns: columns,
                            selectedPcn,
                            currentPcn,
                            isPreviewGridMode: false,
                            isPcnModalOpen: false,
                            isGridUpdated: false,
                            frequencies: frequencies ? frequencies as RouteFrequency[] : currentFrequencies
                        });

                        this.showSnackbar(
                            ROUTE_CREATED_SUCCESFULLY,
                            'success' as CCSnackbarVariant
                        );
                    }).catch((error) => {
                        this.showError(error);
                    });
                }).catch((error) => {
                    this.showDialog('ERROR', error);
                });
            } else {
                // EDIT ROUTE
                if (!selectedPcn) {
                    this.onBackToFoldersClicked();
                    this.showError('Error retrieving the selected PCN, please try again');
                    return;
                }

                const selectedPcnId = selectedPcn.pcnId;
                managerStore.getScheduleModulesGroup(folder_id, this.isNewVersion ? selectedPcnId : '', userTeam).then(() => {
                    const getSchedulesRoute = this.isNewVersion ?
                        managerStore.getSchedulesRoutesCPS :
                        managerStore.getSchedulesRoutes;

                    getSchedulesRoute(folder_id, selectedPcnId, userTeam).then((routes) => {
                        this.convertToRows(routes);
                        this.setState({
                            currentPcn,
                            isPreviewGridMode: false,
                            isPcnModalOpen: false
                        });
                    }).catch((error) => {
                        this.onBackToFoldersClicked();
                        this.showError(error);
                    });
                }).catch((error) => {
                    this.onBackToFoldersClicked();
                    this.showError(error);
                });
            }
        }).catch((error) => {
            this.onBackToFoldersClicked();
            this.showError(error);
        });
    };

    setPcnValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        const pcn = `${event.target.value}`.replace('@', '');
        this.setState({ pcnField: pcn });
    };

    setShiftLabel = (event: SelectChangeEvent) => {
        const shiftLabel = JSON.parse(event.target.value);
        this.setState({ currentShiftLabel: shiftLabel });
    };

    setSessionType = (event: SelectChangeEvent) => {
        const { sessionTypes } = this.state;
        const currentSessionType = JSON.parse(event.target.value);
        const shiftLabels = sessionTypes.filter(session => session.name === currentSessionType.name)[0].shift_labels;
        const frequencies = sessionTypes.filter(session => session.name === currentSessionType.name)[0].frequencies;
        const currentShiftLabel = shiftLabels[0];

        this.setState({
            currentSessionType,
            frequencies,
            shiftLabels,
            currentShiftLabel
        });
    };

    selectExistingPCN = (selectedItem: SimpleListItem) => {
        const { sessionTypes, shiftLabels: currShiftLabels } = this.state;
        const {label: pcn, data} = selectedItem;

        if (!data) {
            return;
        }

        const { shiftLabel, sessionType, frequencies: selectedFrequencies } = data;
        const stringFrequencies = selectedFrequencies as string[];
        // Convert frequencies to object
        const frequencies = stringFrequencies.length ? stringFrequencies.map((item: string) => { return JSON.parse(item); }) as RouteFrequency[] : [];
        const currentSessionType = sessionType ? sessionType as { id: number; name: string; } : undefined;
        const shiftLabels = currentSessionType ? sessionTypes.filter(session => session.id === currentSessionType.id)[0].shift_labels : currShiftLabels;
        const updatedColumns = this.convertToColumns(this.defaultColumnsDefinition);

        this.setState({
            selectedPcn: data as unknown as EntityPCN | undefined,
            currentShiftLabel: shiftLabel ? shiftLabel as { id: number; name: string; } : undefined,
            currentSessionType: sessionType ? sessionType as { id: number; name: string; } : undefined,
            frequencies: frequencies as RouteFrequency[],
            isNewSchedule: false,
            shiftLabels,
            gridColumns: updatedColumns
        }, () => {
            this.submitPCN(pcn);
        });
    };

    onCreatePcnNewPCN = () => {
        const { pcnField } = this.state;
        const updatedColumns = this.convertToColumns(this.defaultColumnsDefinition);

        this.setState({
            isNewSchedule: true,
            gridColumns: updatedColumns
        }, () => {
            this.submitPCN(pcnField);
        });
    };

    onShowMarkersClicked = () => {
        const {
            rootStore: {
                managerStore: {
                    folderFloorplans
                }
            }
        } = this.props;

        const floorplanItems = folderFloorplans.map( (floorplan: Floorplan) => {
            const { id, name } = floorplan;
            return new SimpleListItem(id, name);
        });

        this.setState({
            isMapsSectionOpen: true,
            floorplanList: floorplanItems
        });
        
    };

    onSelectFloorplanToMap = (selectedItem: SimpleListItem) => {
        const { id: floorplanId, label: floorplanName } = selectedItem;
        const {
            rootStore: { 
                managerStore
            }
        } = this.props;

        managerStore.getMarkersCoordinates(floorplanId).then((markers: PDFApiMarker[]) => {
            managerStore.getFloorplanImage(floorplanId).then((pdfData: PDF2JPGConvertion) => {
                const leafletPayload: LeafletPDFData = {
                    markers,
                    pdf: pdfData,
                    is_leaflet_ready: true
                };

                this.setState({
                    selectedFloorplan: { floorplanId, floorplanName },
                    leafletPayload
                });
            }).catch((error) => {
                this.showError(error);
            });
        }).catch((error) => {
            this.showError(error);
        });
    };

    onShowGridClicked = () => {
        this.setState({
            isMapsSectionOpen: false,
            selectedFloorplan: undefined
        });
    };

    generateTodayRoutePDFPage = () => {
        const {
            rootStore: { 
                managerStore: { 
                    schedulesRoutesRows,
                    getPCNFilterList
                }
            },
            userTeam
        } = this.props;
        const { selectedPcn, selectedFolder } = this.state;

        if (!selectedPcn || !selectedFolder) {
            this.showError(
                `There is no folder and route selected`
            );
            return;
        }
        const { pcnId, pcnValue, shiftLabel } = selectedPcn;
        const { folder_id, folder_name } = selectedFolder;
        // The margin top/bottom for the PDF page
        const verticalMargin = 20;

        // Coordinates values are the absolute measures that jsPDF uses for PDF file creation
        // this values starting as X and Y axis positions (X=0 and Y=0 means the top left corner of page)
        // Check https://github.com/MrRio/jsPDF for more info
        let verticalCoordinate = verticalMargin;

        // The margin right for the PDF file
        const marginHorizontal = 20;

        function getNextVerticalCoordinate(
            rowsAdded = 1,
            nextLineIncrement = 6,
            additionalLineIncrement = 0
        ): number {
            const currentValue = verticalCoordinate;
            verticalCoordinate +=
                rowsAdded * nextLineIncrement + additionalLineIncrement;
            return currentValue;
        }

        // Get numbers from 0 (Sunday) to 6 (Saturday)
        const weekDayNumber = this.currentDate.day();
        const weekDay = WEEKDAYS[weekDayNumber];
        const currentDayRoute = schedulesRoutesRows.filter((row) => {
            return weekDay in row;
        }).map((item) => {
            const { markerId, markerName, floorplanName } = item;
            return {
                markerId,
                markerName,
                floorplanName,
                [weekDay]: item[weekDay]
            };
        });

        if (!currentDayRoute.length) {
            this.showDialog(
                `There are no markers to download`,
                `${pcnValue} route must have at least one marker selected for today`
            );
            return;
        }

        let user = 'UNASSIGNED';
        getPCNFilterList({ secondary_id_row_id: pcnId, folder_id: folder_id }, userTeam).then(({ rows }) => {
            if (!rows.length) {
                this.showWarning(`There are no results related with this route number ${pcnId}`);
                return;
            }

            const pcnRow = rows[0];
            if ('email' in pcnRow) {
                user = pcnRow['email'] as string;
            }

            const markersGroups = splitList(currentDayRoute, 11);
            const pdfDocument = new jsPDF({ format: 'letter' });
            const routeTitle = CC_ROUTES_NAME ? `${CC_ROUTES_NAME} Route: ${pcnValue}` : `Route: ${pcnValue}`;

            for (let i = 0; i < markersGroups.length; i++) {
                if (i > 0) {
                    pdfDocument.addPage();
                    verticalCoordinate = verticalMargin;
                }

                pdfDocument.addImage(ccLogoBottom, 'PNG', 170, 5, 30, 18);
                if (CC_ROUTES_NAME && CC_ROUTES_NAME in PDF_LOGO) {
                    pdfDocument.addImage(PDF_LOGO[CC_ROUTES_NAME], 'PNG', 170, 28, 30, 14);
                }
                pdfDocument
                    .setFont('Helvetica', 'bold')
                    .setFontSize(18)
                    .text(`Today's Route`, marginHorizontal, getNextVerticalCoordinate(2))
                    .setFont('Helvetica', 'normal')
                    .setFontSize(12)
                    .text(
                        [
                            this.currentDate.format('dddd, MMMM D, YYYY'),
                            routeTitle,
                            `School: ${folder_name} - ${shiftLabel}`,
                            `User Assigned: ${user}`
                        ],
                        marginHorizontal,
                        getNextVerticalCoordinate(5)
                    )
                    .setFontSize(18)
                    .text('Markers', marginHorizontal, getNextVerticalCoordinate(2));

                markersGroups[i].map(({markerName, floorplanName}) => {
                    pdfDocument
                        .setFontSize(14)
                        .setTextColor('#000')
                        .rect(188, verticalCoordinate - 4, 8, 8)
                        .text(markerName, marginHorizontal, getNextVerticalCoordinate())
                        .setFontSize(12)
                        .setTextColor('#666')
                        .text(floorplanName, marginHorizontal, getNextVerticalCoordinate(2));
                });
            }

            pdfDocument.save(
                `cc-route-${pcnValue}-${this.currentDate.format('L')}.pdf`
            );
        }).catch((error) => {
            this.showError(error);
            return;
        });
    };

    generateTodayRoutePDFPageV3 = () => {
        const {
            rootStore: { 
                managerStore: { 
                    schedulesRoutesRows,
                    getPCNFilterList
                }
            },
            userTeam
        } = this.props;
        const {
            selectedPcn,
            selectedFolder,
            currentSessionType,
            currentShiftLabel,
            frequencies
        } = this.state;

        if (!selectedPcn || !selectedFolder) {
            this.showError(
                `There is no folder and route selected`
            );
            return;
        }
        const { pcnId, pcnValue } = selectedPcn;
        const { folder_id, folder_name } = selectedFolder;
        // The margin top/bottom for the PDF page
        const verticalMargin = 20;

        // Coordinates values are the absolute measures that jsPDF uses for PDF file creation
        // this values starting as X and Y axis positions (X=0 and Y=0 means the top left corner of page)
        // Check https://github.com/MrRio/jsPDF for more info
        let verticalCoordinate = verticalMargin;

        // The margin right for the PDF file
        const marginHorizontal = 20;

        function getNextVerticalCoordinate(
            rowsAdded = 1,
            nextLineIncrement = 6,
            additionalLineIncrement = 0
        ): number {
            const currentValue = verticalCoordinate;
            verticalCoordinate +=
                rowsAdded * nextLineIncrement + additionalLineIncrement;
            return currentValue;
        }

        // Get numbers from 0 (Sunday) to 6 (Saturday)
        const weekDayNumber = this.currentDate.day();
        const monthDayNumber = this.currentDate.date();
        const weekDay = WEEKDAYS[weekDayNumber];
        const allDaysFrequencyList = ['weekly', 'two_weeks', 'monthly', 'summer_break'];
        const currentDayRoute = schedulesRoutesRows.filter((gridRow) => {
            const { days, frequency} = gridRow;

            if (allDaysFrequencyList.includes(frequency)) {
                return true;
            }

            const row = days.split(',');
            return row.includes(weekDay) || row.includes(`${monthDayNumber}`);
        }).map((item) => {
            const { markerId, markerName, floorplanName, frequency, days, moduleGroup } = item;
            return {
                markerId,
                markerName,
                floorplanName,
                frequency,
                days,
                moduleGroup
            };
        });

        if (!currentDayRoute.length) {
            this.showDialog(
                `There are no markers to download`,
                `${pcnValue} route must have at least one marker selected for today`
            );
            return;
        }

        let user = 'UNASSIGNED';
        getPCNFilterList({ secondary_id_row_id: pcnId, folder_id: folder_id }, userTeam).then(({ rows }) => {
            if (!rows.length) {
                this.showWarning(`There are no results related with this route number ${pcnId}`);
                return;
            }

            const pcnRow = rows[0];
            if ('email' in pcnRow) {
                user = pcnRow['email'] as string;
            }

            const markersGroups = splitList(currentDayRoute, 11);
            const pdfDocument = new jsPDF({ format: 'letter' });
            const routeTitle = CC_ROUTES_NAME ? `${CC_ROUTES_NAME} Route: ${pcnValue}` : `Route: ${pcnValue}`;

            for (let i = 0; i < markersGroups.length; i++) {
                if (i > 0) {
                    pdfDocument.addPage();
                    verticalCoordinate = verticalMargin;
                }

                pdfDocument.addImage(ccLogoBottom, 'PNG', 170, 5, 30, 18);
                if (CC_ROUTES_NAME && CC_ROUTES_NAME in PDF_LOGO) {
                    pdfDocument.addImage(PDF_LOGO[CC_ROUTES_NAME], 'PNG', 170, 28, 30, 14);
                }

                const schoolTitle = `${folder_name}, ${currentSessionType?.name} - ${currentShiftLabel?.name}`;
                pdfDocument
                    .setFont('Helvetica', 'bold')
                    .setFontSize(18)
                    .text(`Today's Route`, marginHorizontal, getNextVerticalCoordinate(2))
                    .setFont('Helvetica', 'normal')
                    .setFontSize(12)
                    .text(
                        [
                            this.currentDate.format('dddd, MMMM D, YYYY'),
                            routeTitle,
                            `School: ${schoolTitle}`,
                            `User Assigned: ${user}`
                        ],
                        marginHorizontal,
                        getNextVerticalCoordinate(5)
                    )
                    .setFontSize(18)
                    .text('Markers', marginHorizontal, getNextVerticalCoordinate(2));

                markersGroups[i].map(({markerName, floorplanName, moduleGroup, frequency: selectedFrequencyValue}) => {
                    const selectedFrequency = frequencies.filter((frequency: RouteFrequency) => frequency.value === selectedFrequencyValue);
                    const subtitle = `${floorplanName}, ${selectedFrequency.length ? selectedFrequency[0].name : 'No Frequency selected'}`;
                    const moduleGroupText = `${moduleGroup}`;

                    pdfDocument
                        .setFontSize(14)
                        .setTextColor('#000')
                        .rect(188, verticalCoordinate - 4, 8, 8)
                        .text(markerName, marginHorizontal, getNextVerticalCoordinate())
                        .setFontSize(12)
                        .setTextColor('#666')
                        .text(subtitle, marginHorizontal, getNextVerticalCoordinate())
                        .setFontSize(11)
                        .setTextColor('#666')
                        .text(moduleGroupText, marginHorizontal, getNextVerticalCoordinate(2));
                });
            }

            pdfDocument.save(
                `cc-route-${pcnValue}-${this.currentDate.format('L')}.pdf`
            );
        }).catch((error) => {
            this.showError(error);
            return;
        });
    };

    onPCNBufferOverBoundary = (
        boundary: PageBoundary,
        nextPage: number
    ): Promise<void> => {
        return new Promise((resolve) => {
            const {
                rootStore: {
                    managerStore: {
                        pcnRoutesTotal
                    }
                }
            } = this.props;

            const {
                pcnOffset: currentOffset,
                selectedFolder
            } = this.state;

            const { PCN_ROUTES_RECORD_LIMIT, PCN_ROUTES_MAX_ROWS } = PCN_ROUTES;
            const isFirstPage = nextPage === 0;
            const isLastPage =
                nextPage ===
                Math.ceil(pcnRoutesTotal / PCN_ROUTES_MAX_ROWS) - 1;
            let newOffset = isFirstPage
                ? 0
                : isLastPage
                    ? PCN_ROUTES_RECORD_LIMIT * Math.floor(pcnRoutesTotal / PCN_ROUTES_RECORD_LIMIT)
                    : boundary === PageBoundary.Upper
                        ? currentOffset + PCN_ROUTES_RECORD_LIMIT
                        : currentOffset - PCN_ROUTES_RECORD_LIMIT;

            // If we reached exactly the end of the buffer we go one page back
            if (isLastPage && newOffset === pcnRoutesTotal) {
                newOffset -= PCN_ROUTES_RECORD_LIMIT;
            }

            this.setState({
                pcnOffset: newOffset,
                pcnPage: nextPage,
            }, () => {
                
                this.updatePCNList(selectedFolder?.folder_id);
            });

            resolve();
        });
    };

    onOpenEditPCNModal = (isShiftLabelEdit: boolean) => {
        const { isGridUpdated, currentPcn } = this.state;

        const openModal = () => {
            this.setState({
                isOpenEditPCNModal: true,
                pcnField: currentPcn,
                isShiftLabelEdit: isShiftLabelEdit
            });
        };

        if (isGridUpdated) {
            this.showSaveGridModal(openModal);
            return;
        }

        openModal();
    };

    renderPCNList = (folderPCNList: SimpleListItem[]) => {
        const {
            rootStore: {
                managerStore: {
                    pcnRoutesTotal,
                    isPcnRoutesLoading
                }
            },
            classes
        } = this.props;
        const { pcnOffset, pcnModalType } = this.state;
        const { PCN_ROUTES_MAX_ROWS } =  PCN_ROUTES;

        return (
            <>
                {
                    pcnModalType === MODAL_TYPE.DEFAULT && !folderPCNList.length ? ''
                        : <div className={classes.pcnListSection} data-testid="pcn-list">
                            <Typography
                                className={classes.pcnModalTitle}
                                variant="h5"
                            >
                                Select a { CC_ROUTES_NAME } Route
                            </Typography>
                            <SimpleListPagination
                                className={classes.pcnList}
                                items={folderPCNList}
                                onListItemClick={this.selectExistingPCN}
                                rowsPerPage={PCN_ROUTES_MAX_ROWS}
                                onPageOverBoundary={this.onPCNBufferOverBoundary}
                                totalItems={pcnRoutesTotal}
                                offset={pcnOffset}
                                isLoading={isPcnRoutesLoading}
                            />
                        </div>
                }
            </>
        );
    };

    renderShiftLabelDropdown = (shiftLabel?: { id: number, name: string }, sessionLabel?: { id: number, name: string }, isSessionType = false) => {
        const { sessionTypes, shiftLabels } = this.state;

        return (
            <>
                {
                    isSessionType && (
                        <FormControl fullWidth>
                            <InputLabel>Session Type</InputLabel>
                            <Select
                                value={JSON.stringify(sessionLabel)}
                                label="Season Label"
                                onChange={this.setSessionType}
                                data-testid="sessiontype-select"
                            >
                                { 
                                    sessionTypes.map((item) => {
                                        const { name, id } = item;

                                        return (
                                            <MenuItem value={JSON.stringify({id, name})} key={`${name}-${id}`}>{name}</MenuItem>
                                        );
                                    })
                                }
                            </Select>
                        </FormControl>
                    )
                }
                <FormControl style={{marginTop: '1em'}} fullWidth>
                    <InputLabel>Shift Label</InputLabel>
                    <Select
                        value={JSON.stringify(shiftLabel)}
                        label="Shift Label"
                        onChange={this.setShiftLabel}
                        data-testid="shiftlabel-select"
                    >
                        { 
                            shiftLabels.map((item) => {
                                const { name, id } = item;
                                return (
                                    <MenuItem value={JSON.stringify({id, name})} key={`${name}-${id}`}>{name}</MenuItem>
                                );
                            })
                        }
                    </Select>
                </FormControl>
            </>
        );
    };

    onOpenDeletePCNModal = () => {
        const { isGridUpdated } = this.state;

        const openModal = () => {
            this.setState({ isOpenDeletePCNModal: true });
        };

        if (isGridUpdated) {
            this.showSaveGridModal(openModal);
            return;
        }

        openModal();
    };

    onDeleteModal = (type: number) => {
        if (type === 1) {
            const {
                rootStore: {
                    managerStore
                },
                userTeam
            } = this.props;

            const { selectedPcn, selectedFolder, runningJobs } = this.state;
            const { folder_id } = selectedFolder as EntityFolder;
            const { pcnId, pcnValue } = selectedPcn as EntityPCN;

            managerStore.deleteSchedulePcn(pcnId, folder_id, userTeam).then((response) => {
                const { jobId, message } = response;
                const newJob: RunningJobs = {
                    task_name: `Deleting ${pcnValue}`,
                    task_id: jobId,
                    status: 102,
                    type: JobTypes.PCNDeletion,
                    startedAt: Date.now(),
                    elapsedTime: 0,
                    progress: 0,
                    timer: 1500,
                    static_progress_count: 0,
                    set_to_stop: false,
                    result_data: selectedPcn
                };

                // SEND ROUTE DELETION TO JOB
                runningJobs.push(newJob);
                managerStore.setCurrentJobs(runningJobs, MainTabs.Routes);
                this.startTaskWatcher(newJob);

                this.setState({ isOpenDeletePCNModal: false, isGridUpdated: false });
                this.onBackToFoldersClicked();
                this.showDialog(`Route Deleted`, `Deleting Route: ${pcnValue} - ${message}`);
            }).catch((error) => {
                this.showError(error);
                return;
            });
        } else {
            this.setState({ isOpenDeletePCNModal: false });
        }
    };

    public render() {
        const {
            isRoutesDrawerOpen,
            snackbarVariant,
            snackbarMessage,
            snackbarOpen,
            dialogOpen,
            dialogTitle,
            dialogMessage,
            treeFolders,
            treeFoldersClicked,
            treeFoldersExpanded,
            gridRows,
            isCreateNewRoute,
            gridColumns,
            selectedFolder,
            isPreviewGridMode,
            runningJobs,
            currentJobsOffset,
            isPcnModalOpen,
            currentPcn,
            currentShiftLabel,
            currentSessionType,
            isMapsSectionOpen,
            floorplanList,
            selectedFloorplan,
            isNewSchedule,
            pcnModalType,
            pcnField,
            openSaveGridModal,
            selectedPcn,
            isShiftLabelEdit,
            isOpenEditPCNModal,
            isOpenDeletePCNModal,
            showDeletePCNBtn,
            showCreateEditPCNButtons,
            totalMarkers,
            leafletPayload,
            isGridUpdated
        } = this.state;

        const {
            rootStore: {
                managerStore: {
                    isRoutesTabLoading,
                    isFolderFloorplansLoading,
                    isFolderMarkersLoading,
                    isTeamFoldersLoading,
                    isMapLoading,
                    pcnRoutes
                }
            },
            classes
        } = this.props;

        const isTreeLoading = isFolderFloorplansLoading || isTeamFoldersLoading;
        const folderPCNList =
            pcnRoutes ?
                this.convertPCNRoutesIntoListItems(pcnRoutes)
                : [];

        const disableSavePCNChanges = isShiftLabelEdit ? selectedPcn?.shiftLabel === currentShiftLabel?.name : (pcnField.trim() === '' || pcnField.trim() === currentPcn);
        const prefixName = CC_ROUTES_NAME ? CC_ROUTES_NAME : '';
        const routeTitle = this.isNewVersion ? `${currentPcn}, ${currentSessionType?.name} - ${currentShiftLabel?.name}` : `${currentPcn}, ${currentShiftLabel?.name}`;

        return (
            <>
                <SideNavbar
                    variant="persistent"
                    isDrawerOpen={isRoutesDrawerOpen}
                    collapsedArea={
                        <div
                            className={`${classes.navbarIconContainer} ${classes.navbarIconContainerSmall}`}
                        >
                            <ArticleIcon className={classes.navbarIcon} />
                        </div>
                    }
                    onExpanderClick={this.onToggleSideNavBar}
                >
                    <div className={`${classes.contentContainer} ${classes.navbarContent}`}>
                        <div className={classes.navbarTitleContainer}>
                            <div className={classes.navbarIconContainer}>
                                <ArticleIcon className={classes.navbarIcon} />
                            </div>
                            <Typography
                                className={classes.navbarTitle}
                                variant="subtitle1"
                            >
                                { prefixName } Routes Options
                            </Typography>
                        </div>
                        <Divider className={classes.divider} />
                        <div>
                            <Button
                                className={classes.routeNavButton}
                                onClick={this.onShowGridClicked}
                                variant="contained"
                                color="primary"
                                size="large"
                                disabled={!isMapsSectionOpen}
                            >
                                <CalendarViewWeekIcon/> Show Grid
                            </Button>
                            <Button
                                className={classes.routeNavButton}
                                onClick={this.onShowMarkersClicked}
                                variant="contained"
                                color="primary"
                                size="large"
                                disabled={!selectedFolder || isMapsSectionOpen}
                            >
                                <PlaceIcon/> Show Markers
                            </Button>
                            { 
                                isMapsSectionOpen ?
                                    <>
                                        <Divider className={classes.divider} />
                                        <Typography
                                            className={classes.navbarComponentTitle}
                                            variant="button"
                                        >
                                            FLOORPLANS
                                        </Typography>
                                        <SimpleList
                                            className={classes.floorplanList}
                                            items={floorplanList}
                                            onListItemClick={this.onSelectFloorplanToMap}
                                            selectedItemId={selectedFloorplan?.floorplanId}
                                        />
                                    </>
                                    : ''
                            }
                        </div>
                        <Divider className={classes.divider} />
                        <Button
                            className={classes.routeNavButton}
                            onClick={this.isNewVersion ? this.generateTodayRoutePDFPageV3 : this.generateTodayRoutePDFPage}
                            variant="contained"
                            color="secondary"
                            size="large"
                            disabled={isNewSchedule || isPreviewGridMode || !selectedFolder}
                        >
                            <PictureAsPdf /> Today`s Route
                        </Button>
                        <Button
                            className={classes.routeNavButton}
                            onClick={this.onBackToFoldersClicked}
                            variant="contained"
                            color="secondary"
                            size="large"
                            disabled={!selectedFolder}
                        >
                            <ApartmentIcon/> Back to Buildings
                        </Button>
                        {
                            (runningJobs && (runningJobs.length > 0)) &&
                            <>
                                <div className={`${classes.navbarTitleContainer} ${classes.topMargin}`}>
                                    <div className={classes.navbarIconContainer}>
                                        <HourglassBottom className={classes.navbarIcon} />
                                    </div>
                                    <Typography
                                        className={classes.navbarTitle}
                                        variant="subtitle1"
                                    >
                                        Routes Processing
                                    </Typography>
                                </div>
                                <Divider className={classes.divider} />
                                <RunningJobsList
                                    className={classes.tasksContainerSize}
                                    classes={{
                                        buttonClear: classes.routeNavButton
                                    }}
                                    tasks={runningJobs}
                                    rowsPerPage={TASKS_ROWS_PER_PAGE}
                                    taskItemsOffset={currentJobsOffset}
                                    onJobsDataPageOverBoundary={this.onJobsDataPageOverBoundaryReached}
                                    onJobClear={this.onJobClear}
                                    onJobClick={this.onJobClick}
                                />
                            </>
                        }
                    </div>
                </SideNavbar>
                {
                    selectedFolder ?
                        isMapsSectionOpen ?
                            <div className={classes.mapContainer}>
                                <Typography
                                    className={classes.bodyTitle}
                                    variant="h4"
                                >
                                    Select a Floorplan from {selectedFolder.folder_name}
                                </Typography>
                                {
                                    selectedFloorplan && leafletPayload ?
                                        <LeafletPDFClient
                                            className={`${classes.animContainer} ${classes.thinClientContainer}`}
                                            classes={{fullScreenContainer: classes.fullScreenContainer, warningToast: classes.warningLeafletToast}}
                                            floorplanName={selectedFloorplan!.floorplanName}
                                            floorplanId={selectedFloorplan!.floorplanId}
                                            floorplanPayload={leafletPayload!}
                                            isReadOnly={true}
                                        />
                                        : <div className={classes.mapWrapper}></div>
                                }
                            </div>
                            :
                            <div className={`${classes.dataGridContainer} ${isRoutesDrawerOpen ? 'navbar-opened' : ''}`}>
                                {
                                    isCreateNewRoute ?
                                        <Typography
                                            className={classes.bodyTitle}
                                            variant="h4"
                                        >
                                            { 
                                                isPreviewGridMode ?
                                                    `New Route created preview for ${selectedFolder?.folder_name} - ${prefixName} Route: ${routeTitle}`
                                                    : `New Building: ${selectedFolder?.folder_name} - ${prefixName} Route: ${routeTitle}`
                                            }
                                        </Typography>
                                        :
                                        <Typography
                                            className={classes.bodyTitle}
                                            variant="h4"
                                        >
                                            Building: {selectedFolder.folder_name} {currentPcn !== '' && !isPcnModalOpen ? `- ${prefixName} Route: ${routeTitle}` : ''}
                                        </Typography>
                                }
                                <div className={classes.pcnActionsContainer}>
                                    <Typography
                                        variant="subtitle1"
                                    >
                                        { totalMarkers > 0 ? `Markers selected ${totalMarkers}` : `No markers selected`}
                                    </Typography>
                                    <div>
                                        <Button
                                            color="primary"
                                            onClick={this.showPCNList}
                                            disabled={!folderPCNList.length}
                                            startIcon={<ListIcon/>}
                                        >
                                            Show Routes
                                        </Button>
                                        {
                                            !selectedPcn || isCreateNewRoute ? ''
                                                : <>
                                                    {
                                                        showCreateEditPCNButtons ?
                                                            <>
                                                                <Button
                                                                    color="primary"
                                                                    onClick={this.createOtherPCN}
                                                                    disabled={isCreateNewRoute && !isPreviewGridMode}
                                                                    startIcon={<AddIcon />}
                                                                >
                                                                    Create New Route
                                                                </Button>
                                                                <Button
                                                                    className={classes.gridActionsBtn}
                                                                    onClick={() => this.onOpenEditPCNModal(true)}
                                                                    data-testid="edit-shiftlabel-button"
                                                                >
                                                                    <EditCalendarIcon /> Edit Shift Label
                                                                </Button>
                                                                <Button
                                                                    className={classes.gridActionsBtn}
                                                                    onClick={() => this.onOpenEditPCNModal(false)}
                                                                    data-testid="edit-pcn-button"
                                                                >
                                                                    <EditCalendarIcon /> Edit Route
                                                                </Button>
                                                            </>
                                                            : ''
                                                    }
                                                    {
                                                        showDeletePCNBtn ?
                                                            <Button
                                                                className={classes.gridActionsBtn}
                                                                onClick={() => this.onOpenDeletePCNModal()}
                                                                data-testid="delete-pcn-button"
                                                            >
                                                                <DeleteIcon /> Delete Route
                                                            </Button>
                                                            : ''

                                                    }
                                                </>
                                        }
                                    </div>
                                </div>
                                <Divider className={classes.divider} />
                                <AgGridList
                                    className={classes.gridWrapper}
                                    isLoading={isFolderMarkersLoading || isRoutesTabLoading}
                                    isDisabledSaveButton={!isGridUpdated}
                                    // isDisabledEditMode={isGridUpdated}
                                    startAsEditableMode={isCreateNewRoute && !isPreviewGridMode}
                                    rows={gridRows}
                                    columns={gridColumns}
                                    onGridReady={this.onGridReady}
                                    onGridSaved={this.onGridSaved}
                                    onGridChanged={this.onGridChanged}
                                    onGridExport={this.onGridExport}
                                    pagination={true}
                                    paginationPageSize={100}
                                    paginationPageSizeSelector={[25, 50, 100]}
                                    rowHeight={50}
                                    enableCellSpan={true}
                                    cellSelectionOptions={{
                                        handle: {
                                            // Enable fill cells by dragging
                                            mode: 'fill',
                                            // Disable clear cell when dragging
                                            suppressClearOnFillReduction: true,
                                            setFillValue(params) {
                                                // Avoid to set new value on the module group cell
                                                if (params.column.getColId() === 'moduleGroup') {
                                                    return !params.currentCellValue ? '' : params.currentCellValue;
                                                }
                                                // Fill cell with the latest value
                                                return params.values[params.values.length - 1];
                                            }
                                        }
                                    }}
                                    saveModalMessage={
                                        `Reminder to select the row(s) before saving, any unselected markers will not be saved.
                                        Are you sure, to save changes?`
                                    }
                                />
                                <span className={classes.gridHint}>
                                    * Reminder to select the row(s) before saving, any unselected markers will not be saved.
                                </span>
                            </div>
                        :
                        <div className={classes.treeContainer}>
                            <Typography
                                className={classes.bodyTitle}
                                variant="h5"
                            >
                                Select a Building to Check or Edit
                            </Typography>
                            <FolderTree
                                folderTreeData={treeFolders}
                                foldersClicked={treeFoldersClicked}
                                foldersExpanded={treeFoldersExpanded}
                                onFolderTreeClick={this.onFolderTreeClick}
                                onSelectFolder={this.onSelectFolder}
                                onFolderTreeToggle={this.onFolderTreeToggle}
                                isLoading={isTreeLoading}
                            />
                        </div>
                }
                <SimpleModal
                    className={pcnModalType === MODAL_TYPE.DEFAULT ? classes.pcnModal : classes.pcnModalLight}
                    open={isPcnModalOpen}
                    buttonOkLabel=""
                    onModalResult=""
                    footer={
                        <div className={classes.pcnModalFooter}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={pcnModalType === MODAL_TYPE.DEFAULT ? this.onBackToFoldersClicked : this.onClosePCNModal}
                            >
                                Cancel
                            </Button>
                            {
                                pcnModalType === MODAL_TYPE.LIST ? ''
                                    : <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.onCreatePcnNewPCN}
                                        disabled={pcnField.trim() === ''}
                                        data-testid="create-pcn-button"
                                    >
                                        Create
                                    </Button>
                            }
                        </div>
                    }
                >
                    <div className={classes.pcnModalContent}>
                        {
                            pcnModalType === MODAL_TYPE.NEW ? '' : this.renderPCNList(folderPCNList)
                        }
                        {
                            pcnModalType === MODAL_TYPE.LIST ? ''
                                : <div className={classes.pcnFormSection}>
                                    <Typography
                                        className={classes.pcnModalTitle}
                                        variant="h5"
                                    >
                                        Create a New { prefixName } Route
                                    </Typography>
                                    <div className={classes.pcnModalContainer}>
                                        <TextField
                                            className={classes.pcnInput}
                                            label="Enter Route number"
                                            variant="outlined"
                                            onChange={this.setPcnValue}
                                            placeholder="Enter Route number"
                                        />
                                        { this.renderShiftLabelDropdown(currentShiftLabel, currentSessionType, this.isNewVersion) }
                                    </div>
                                </div>
                        }
                    </div>
                </SimpleModal>
                <SimpleModal
                    className={classes.pcnModalLight}
                    open={isOpenEditPCNModal}
                    buttonOkLabel=""
                    buttonCancelLabel=""
                    footer={
                        <div className={classes.pcnModalFooter}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.onCloseEditPCNModal}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.onEditPCNModal}
                                disabled={disableSavePCNChanges}
                                data-testid="save-pcn-button"
                            >
                                Save Changes
                            </Button>
                        </div>
                    }
                >
                    <>
                        <Typography
                            className={classes.pcnModalTitle}
                            variant="h5"
                        >
                            Edit { prefixName } Route: {currentPcn}
                        </Typography>
                        <div className={classes.pcnModalContainer}>
                            {
                                isShiftLabelEdit ? this.renderShiftLabelDropdown(currentShiftLabel, currentSessionType)
                                    : <TextField
                                        className={classes.pcnInput}
                                        label="Route"
                                        variant="outlined"
                                        onChange={this.setPcnValue}
                                        placeholder="Enter Route number"
                                        value={pcnField}
                                        data-testid="edit-pcn-input"
                                    />
                            }
                        </div>
                    </>
                </SimpleModal>
                <CCSnackbar
                    className={classes.snackbar}
                    variant={snackbarVariant}
                    message={snackbarMessage}
                    autoHideDuration={4000}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transition="right"
                    open={snackbarOpen}
                    onClose={this.onSnackbarClosed}
                />
                <SimpleDialog
                    open={dialogOpen}
                    titleText={dialogTitle}
                    buttonCancelLabel=""
                    contentText={dialogMessage}
                    onDialogResult={this.onDialogClosed}
                    disableTransition={true}
                />
                <SimpleModal
                    className={classes.modal}
                    open={openSaveGridModal}
                    onModalResult={this.onGridSaveModal}
                    buttonOkLabel="Save before continue"
                    buttonCancelLabel="Continue without saving"
                >
                    Do you want to save the pending grid changes, before leaving?
                </SimpleModal>
                <SimpleModal
                    className={classes.modal}
                    open={isOpenDeletePCNModal}
                    onModalResult={this.onDeleteModal}
                    buttonOkLabel="Delete"
                    buttonCancelLabel="Cancel"
                >
                    <>
                        <Typography
                            variant="h5"
                        >
                            Delete { prefixName } Route
                        </Typography>
                        <div className={classes.pcnModalContainer}>
                            This is a permanent delete for the route - <strong>{currentPcn}</strong>.<br/>
                            Are you sure you want to permanently delete this route: <strong>{currentPcn}</strong>?
                        </div>
                    </>
                </SimpleModal>
                <CCSpinner
                    className={classes.spinner}
                    loading={isRoutesTabLoading || isFolderMarkersLoading || isMapLoading}
                    overlayVisible={true}
                    size={100}
                />
            </>
        );
    }

}

const MUIComponent = withStyles(styles)(RoutesTab);
export { MUIComponent as RoutesTab };
